import { API_ROUTES } from "../../config/baseURL";
import request from "../clientsApi";

const calculadorasDinamicasApi = {
  getAll: ({ estado, search } = {}) => {
    const qs = new URLSearchParams();
    if (estado !== undefined && estado !== null && estado !== "") {
      qs.set("estado", estado);
    }
    if (search) qs.set("search", search);
    const url = qs.toString()
      ? `${API_ROUTES.calculadorasDinamicas}?${qs.toString()}`
      : API_ROUTES.calculadorasDinamicas;
    return request(url).then((r) => r.json());
  },

  getById: (id) =>
    request(API_ROUTES.calculadorasDinamicasById(id)).then((r) => r.json()),

  getDefinition: (id) =>
    request(API_ROUTES.calculadorasDinamicasDefinition(id)).then((r) => r.json()),

  getSources: ({ estado, search } = {}) => {
    const qs = new URLSearchParams();
    if (estado !== undefined && estado !== null && estado !== "") {
      qs.set("estado", estado);
    }
    if (search) qs.set("search", search);
    const url = qs.toString()
      ? `${API_ROUTES.calculadorasDinamicasFuentes}?${qs.toString()}`
      : API_ROUTES.calculadorasDinamicasFuentes;
    return request(url).then((r) => r.json());
  },

  getSourceById: (id) =>
    request(API_ROUTES.calculadorasDinamicasFuenteById(id)).then((r) => r.json()),

  save: (data) =>
    request(API_ROUTES.calculadorasDinamicas, {
      method: data.id ? "PUT" : "POST",
      body: JSON.stringify(data),
    }).then((r) => r.json()),

  saveSource: (data) =>
    request(API_ROUTES.calculadorasDinamicasFuentes, {
      method: data.id ? "PUT" : "POST",
      body: JSON.stringify(data),
    }).then((r) => r.json()),

  updateEstado: (id, estado) =>
    request(API_ROUTES.calculadorasDinamicasEstado, {
      method: "PUT",
      body: JSON.stringify({ id, estado }),
    }).then((r) => r.json()),

  getPublicadas: (sexo, edad) =>
    request(API_ROUTES.calculadorasDinamicasPublicadas(sexo, edad)).then((r) =>
      r.json()
    ),
};

export default calculadorasDinamicasApi;

